import { render } from "./RolesManager.vue?vue&type=template&id=b75b5d8c"
import script from "./RolesManager.vue?vue&type=script&lang=js"
export * from "./RolesManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__